// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui[class*='bottom attached'].menu {\n  margin-bottom: 0rem !important;\n}\n.ui.menu {\n  display: flex;\n  margin: 1rem 0;\n  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: 400;\n  border: 0px solid rgba(34, 36, 38, 0.15) !important;\n  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15) !important;\n  border-radius: 0rem !important;\n  min-height: 2.85714286em;\n  background: linear-gradient(45deg, #b2dfdb 30%, #1976d2 90%) !important;\n}\n", ""]);
// Exports
module.exports = exports;
